import { MediaLibError } from "@editor/modules/media-lib/components/media-lib-error";
import type {
  IMediaLibDialogItem,
  TElement,
} from "@editor/modules/media-lib/types";
import { cn } from "@lib/cn";
import type { IBrandfetchBrand } from "@/shared/types";
import { MediaLibLogoFinderCtxProvider } from "../ctx";
import { useMediaLibFetchLogos } from "../hooks";
import type { IMediaLibLogo } from "../types";
import { LogoFinderGrid } from "./logo-finder-grid";
import { LogoFinderRateLimit } from "./logo-finder-logo-rate-limit";
import { LogoFinderSkeleton } from "./logo-finder-skeleton";

interface IProps {
  className?: string;
  logosData: IMediaLibLogo[];

  setSearchQuery: (value: string) => void;
  setLogosData: (value: IMediaLibLogo[]) => void;
  updateLogoData: (idx: number, value: Partial<IMediaLibLogo>) => void;
  setBrand: (value: IBrandfetchBrand | null) => void;
  brand: IBrandfetchBrand | null;

  view?: "panel" | "dialog";
  isMultiSelect?: boolean;
  selectedItems?: IMediaLibDialogItem[];
  onSelect?: (item: IMediaLibLogo) => void;
  elementWrapper?: React.ComponentType<{
    children: React.ReactNode;
    element: TElement;
  }>;
}

export const LogoFinderContainer = ({ className, ...props }: IProps) => {
  const { logosData, setLogosData, brand, setBrand, setSearchQuery } = props;

  const { isError, isRateLimitError, isLoading, reloadData } =
    useMediaLibFetchLogos({
      logosData,
      setLogosData,
      brand,
      setBrand,
      setSearchQuery,
    });

  const hasError = isError;
  return (
    <MediaLibLogoFinderCtxProvider ctxState={props}>
      <div className={cn("tw-relative tw-size-full", className)}>
        {hasError ? (
          <MediaLibError className="tw-mt-0" onReload={reloadData} />
        ) : isRateLimitError ? (
          <LogoFinderRateLimit />
        ) : isLoading ? (
          <LogoFinderSkeleton />
        ) : (
          <LogoFinderGrid />
        )}
      </div>
    </MediaLibLogoFinderCtxProvider>
  );
};
